<template>
  <div class="PWR01G04">
    <div class="title_h1_s">作業日程変更</div>
    <vab-form ref="form" label-position="left" :model="form" :rules="rules">
      <div
        v-for="(item, index) in form.list"
        :key="index"
        class="ts_box form_box"
      >
        <div
          class="flex_space head_box flex_center_align"
          :class="{ margin_bottom_12: item.workFold }"
        >
          <div class="flex_center_align">
            <img src="~@/assets/images/r16.png" alt="" />
            <span v-if="form.list.length > 1" class="hd_title">
              <slot name="hd_title">
                依頼{{ index + 1 }}（作業No：{{
                  getFieldValue('workNo', item)
                }}）
              </slot>
            </span>
            <span v-else class="hd_title">
              <slot name="hd_title">
                作業No：{{ getFieldValue('workNo', item) }}
              </slot>
            </span>
          </div>
          <svg-icon
            icon-class="up_line"
            class="arrow_svg"
            :class="{ rote: item.workFold }"
            @click="item.workFold = !item.workFold"
          />
        </div>
        <div v-if="item.workFold">
          <div class="flex_start flex_center_align margin_bottom_6">
            <div class="split_line"></div>
            <span class="box_title">基本情報</span>
          </div>
          <div class="sure_box top_info mtn margin_bottom_12">
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">発注No連番</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{ getFieldValue('acceptOrderNoSeq', item) }}
                  </div>
                </div>
              </vab-col>
              <vab-col :span="4" class="title_box">作業年月</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{
                      getFieldValue('workYm', item)
                        ? $dayjs(
                            getFieldValue('workYm', item).toString()
                          ).format('YYYY/MM')
                        : ''
                    }}
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">建物</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{ getFieldValue('blgsnmkj', item) }}
                  </div>
                  <div class="sub_title">
                    （建物CD：{{ getFieldValue('buildingCd', item) }}）
                  </div>
                </div>
              </vab-col>
              <vab-col :span="4" class="title_box">管理形態</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{
                      getEnumText(
                        getFieldValue('mngfrm', item),
                        $divisions.manageFormEnum
                      )
                    }}
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">商品明細</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{ getFieldValue('itmdtlnm', item) }}
                  </div>
                  <div class="sub_title">
                    （商品明細CD：{{ getFieldValue('itemDetailCd', item) }}）
                  </div>
                </div>
              </vab-col>
              <vab-col :span="4" class="title_box">点検仕様</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{ getFieldValue('workSpecName', item) }}
                  </div>
                  <div class="sub_title">
                    （点検仕様CD：{{ getFieldValue('workSpecCd', item) }}）
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">協力会社</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{ getFieldValue('bcnfrkj', item) }}
                  </div>
                  <div class="sub_title">
                    （協力会社CD：{{ getFieldValue('supplierCd', item) }}）
                  </div>
                </div>
              </vab-col>
              <vab-col :span="4" class="title_box">発注金額</vab-col>
              <vab-col :span="8" class="word_box flex_center_align flex_end">
                {{ moneyFormat(getFieldValue('costPrice', item)) }}
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">作業条件</vab-col>
              <vab-col :span="20">
                <vab-row>
                  <vab-col class="table_header br" :span="24">
                    日程調整不要
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col :span="24" class="word_box8 br flex_center_align">
                    {{
                      getEnumTextChange(
                        getFieldValue(
                          'weekdayConditionSpecify.adjustUnnecessaryFlg',
                          item
                        ),
                        $divisions.unnecessaryFlagEnum
                      )
                    }}
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col class="table_header br" :span="12">
                    FM不在の場合
                  </vab-col>
                  <vab-col class="table_header" :span="12">要日程調整</vab-col>
                </vab-row>

                <vab-row>
                  <vab-col :span="12" class="word_box8 br flex_center_align">
                    {{
                      isEqualCodeEnum(
                        item.weekdayConditionSpecify.adjustUnnecessaryFlg,
                        $divisions.unnecessaryFlagEnum.enum_blank
                      )
                        ? getEnumTextChange(
                            getFieldValue(
                              'weekdayConditionSpecify.fmAbsentCheckableFlg',
                              item
                            ),
                            $divisions.checkableFlgEnum
                          )
                        : '-'
                    }}
                  </vab-col>
                  <vab-col :span="12" class="word_box8 flex_center_align">
                    {{
                      getEnumTextChange(
                        getFieldValue(
                          'weekdayConditionSpecify.needAdjustFlg',
                          item
                        ),
                        $divisions.necessaryFlagEnum
                      )
                    }}
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col class="table_header" :span="24">曜日指定</vab-col>
                </vab-row>
                <vab-row>
                  <vab-col :span="24" class="word_box8 flex_center_align">
                    {{
                      getTextValue(
                        getFieldValue(
                          'weekdayConditionSpecify.weekdayLimitContentText',
                          item
                        )
                      )
                    }}
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col class="table_header br flex_center_align" :span="12">
                    日付指定
                  </vab-col>
                  <vab-col class="table_header flex_center_align" :span="12">
                    時間指定
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col :span="12" class="word_box8 br flex_colum">
                    <div
                      v-if="
                        getFieldValue(
                          'weekdayConditionSpecify.dateLimitContentCanText',
                          item
                        )
                      "
                      class="pre_wrap"
                    >
                      {{
                        getTextValue(
                          getFieldValue(
                            'weekdayConditionSpecify.dateLimitContentCanText',
                            item
                          )
                        )
                      }}
                    </div>
                    <div
                      v-if="
                        getFieldValue(
                          'weekdayConditionSpecify.dateLimitContentCannotText',
                          item
                        )
                      "
                    >
                      {{
                        getTextValue(
                          getFieldValue(
                            'weekdayConditionSpecify.dateLimitContentCannotText',
                            item
                          )
                        )
                      }}
                    </div>
                  </vab-col>
                  <vab-col :span="12" class="word_box8">
                    {{
                      getTextValue(
                        getFieldValue(
                          'weekdayConditionSpecify.timeLimitContentText',
                          item
                        )
                      )
                    }}
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col class="table_header br flex_center_align" :span="12">
                    お知らせ文
                  </vab-col>
                  <vab-col class="table_header flex_center_align" :span="12">
                    報告書
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col :span="12" class="word_box8 br flex_center_align">
                    {{
                      getTextValue(
                        getFieldValue(
                          'weekdayConditionSpecify.notifyText',
                          item
                        )
                      )
                    }}
                  </vab-col>
                  <vab-col :span="12" class="word_box8 flex_center_align">
                    {{
                      getTextValue(
                        getFieldValue(
                          'weekdayConditionSpecify.reportText',
                          item
                        )
                      )
                    }}
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col class="table_header" :span="24">
                    自由コメント
                  </vab-col>
                </vab-row>
                <vab-row>
                  <vab-col :span="24" class="word_box8 flex_center_align">
                    <div class="pre_wrap">
                      {{
                        getTextValue(
                          getFieldValue(
                            'weekdayConditionSpecify.freeComment',
                            item
                          )
                        )
                      }}
                    </div>
                  </vab-col>
                </vab-row>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">ステータス</vab-col>
              <vab-col :span="20" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{
                      getEnumTextChange(
                        getFieldValue('changeStatus', item),
                        $divisions.wparStatusEnum
                      )
                    }}
                  </div>
                </div>
              </vab-col>
            </vab-row>
          </div>
          <div class="flex_start flex_center_align margin_bottom_6">
            <div class="split_line"></div>
            <span class="box_title">依頼情報</span>
          </div>
          <div class="span_subtitle flex_center_align">
            <svg-icon icon-class="warning_line" />
            支払い条件：完了確認月末締め翌月20日払い
          </div>
          <div class="sure_box top_info mtn">
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">依頼日</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{ getFieldValue('changeRequestDate', item) }}
                  </div>
                </div>
              </vab-col>
              <vab-col :span="4" class="title_box">調整理由</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{ getFieldValue('notAllowDateReason', item) }}
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">依頼内容</vab-col>
              <vab-col :span="8" class="word_box padding_3_12">
                <template v-if="isChangeCategory(item) && !item.isMonthFlg">
                  <vab-select
                    ref="changeCategoryRef"
                    :prop="`list.${index}.changeCategory`"
                    label="依頼種別"
                    label-width="110px"
                    :data-items="changeCategoryList"
                    label-id="text"
                    value-id="value"
                    validate="required"
                    class="width_80"
                    placeholder="選択されていません"
                    @change="
                      (val) => {
                        changeSelectCategory(val, index)
                      }
                    "
                  />
                  <vab-date-picker
                    type="month"
                    label="変更後の月"
                    label-width="110px"
                    class="width_80"
                    value-format="yyyyMM"
                    format="M月"
                    :prop="`list.${index}.changeMonth`"
                    :disabled="item.monthDisabled"
                  />
                  <vab-input
                    :prop="`list.${index}.changeWorkNo`"
                    label="変更後作業No"
                    label-width="110px"
                    class="width_80"
                    :disabled="true"
                  />
                </template>
                <template v-else>
                  <div class="flex_space flex_center_align">
                    <div class="flex_auto line_height">
                      依頼種別：{{
                        getEnumText(
                          getFieldValue('changeCategory', item),
                          $divisions.changeCategoryEnum
                        )
                      }}
                    </div>
                  </div>
                  <div class="flex_space flex_center_align">
                    <div class="flex_auto line_height">
                      変更後の月：{{
                        getChangeMonth(getFieldValue('changeMonth', item))
                      }}
                    </div>
                  </div>
                  <div class="flex_space flex_center_align">
                    <div class="flex_auto line_height">
                      変更後作業No：{{ getFieldValue('changeWorkNo', item) }}
                    </div>
                  </div>
                </template>
              </vab-col>
              <vab-col :span="4" class="title_box">日程回答期限</vab-col>
              <vab-col :span="8" class="word_box flex_center_align">
                {{ getFieldValue('answerDeadline', item) || '-' }}
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">変更前日時</vab-col>
              <vab-col :span="8" class="word_box">
                <div class="flex_space flex_center_align ht_box">
                  <div class="flex_center_align line_height">
                    <div
                      v-if="getFieldValue('workChangeDate', item)"
                      class="margin_right_12"
                    >
                      {{ formatWorkPlanDate(item.workChangeDate, item.workYm) }}
                      {{
                        isShow(
                          item.workChangeDate,
                          item.workChangeStartTime,
                          item.workChangeEndTime
                        )
                      }}
                    </div>
                    <div>
                      {{ formatTimeMsel(item.workChangeStartTime, 'HH:mm') }}
                      {{
                        getFieldValue('workChangeStartTime', item) ? '〜' : ''
                      }}
                      {{ formatTimeMsel(item.workChangeEndTime, 'HH:mm') }}
                    </div>
                  </div>
                </div>
              </vab-col>
              <vab-col :span="4" class="title_box">
                作業予定（変更後日時）
              </vab-col>
              <vab-col
                v-if="workChangeSpecial(item)"
                :span="8"
                class="word_box padding_3_12"
                :class="{
                  flex_center_align: !(
                    isEqualCodeEnum(
                      item.changeStatus,
                      $divisions.wparStatusEnum.enum_08
                    ) && !item.isMonthFlg
                  ),
                }"
              >
                <vab-checkbox
                  v-if="
                    isEqualCodeEnum(
                      item.changeStatus,
                      $divisions.wparStatusEnum.enum_08
                    ) && !item.isMonthFlg
                  "
                  label="未定"
                  :nullable="true"
                  @change="
                    (val) => {
                      checkboxWorkPlan(val, index)
                    }
                  "
                />
                <div class="flex_center_align width_265 time_weekshow time_60">
                  <div>
                    <vab-time
                      :prop="`list.${index}.workPlanDate`"
                      :ym="item.workPlanDate"
                      :disabled="item.workDateFlag"
                      :week-show="true"
                      :work-change="true"
                      class="time14"
                      @svgClick="openDay(item, index)"
                      @change="timeReset($event, index)"
                    />
                  </div>
                  <div class="flex_center_align flex_start pd_10">
                    <vab-time-input
                      v-model="item.workPlanStartTime"
                      :disabled="
                        item.workDateFlag ||
                        $baseLodash.isEmpty(item.workPlanDate)
                      "
                      :prop="`list.${index}.workPlanStartTime`"
                      class="time14 work_time"
                      label-error="予定日時"
                      :validate="vaildateTimeStart(item, index)"
                      :row-item="{ isUpdate: true }"
                    />
                    <div class="mg8">〜</div>
                    <vab-time-input
                      v-model="item.workPlanEndTime"
                      :disabled="
                        item.workDateFlag ||
                        $baseLodash.isEmpty(item.workPlanDate)
                      "
                      :prop="`list.${index}.workPlanEndTime`"
                      class="time14 work_time"
                      label-error="予定日時"
                      :validate="vaildateTimeEnd(item, index)"
                      :row-item="{ isUpdate: true }"
                    />
                  </div>
                </div>
              </vab-col>
              <vab-col v-else :span="8" class="word_box">
                <div class="flex_space flex_center_align ht_box">
                  <div class="flex_center_align line_height">
                    <div
                      v-if="getFieldValue('workPlanDate', item)"
                      class="margin_right_12"
                    >
                      {{ formatWorkPlanDate(item.workPlanDate, item.workYm) }}
                      {{
                        isShow(
                          item.workPlanDate,
                          item.workPlanStartTime,
                          item.workPlanEndTime
                        )
                      }}
                    </div>
                    <div>
                      {{ formatTimeMsel(item.workPlanStartTime, 'HH:mm') }}
                      {{ getFieldValue('workPlanStartTime', item) ? '〜' : '' }}
                      {{ formatTimeMsel(item.workPlanEndTime, 'HH:mm') }}
                    </div>
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">現地確認要否</vab-col>
              <vab-col
                :span="8"
                class="word_box radio_box padding_8_12 flex_center_align"
              >
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{
                      getEnumText(
                        getFieldValue('localComfirmFlg', item),
                        $divisions.unnecessaryFlagEnum
                      ) || '-'
                    }}
                  </div>
                </div>
              </vab-col>
              <vab-col :span="4" class="title_box">現地確認</vab-col>
              <vab-col
                v-if="workChangeSpecial(item) && !item.workDateFlag"
                :span="8"
                class="word_box radio_box padding_8_12 flex_center_align"
              >
                <vab-radio-group
                  :ref="'localAdjRef' + index"
                  class="margin_0"
                  :prop="`list.${index}.localAdjFlg`"
                  filter="localAdjFlg"
                  :code-enum="$divisions.localAdjFlgEnum"
                />
              </vab-col>
              <vab-col
                v-else
                :span="8"
                class="word_box radio_box padding_8_12 flex_center_align"
              >
                <div class="flex_space flex_center_align">
                  <div class="flex_auto line_height">
                    {{
                      getEnumText(
                        getFieldValue('localAdjFlg', item),
                        $divisions.localAdjFlgEnum
                      ) || '-'
                    }}
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">協力会社コメント</vab-col>
              <vab-col :span="20" class="word_box padding_8_12">
                <vab-textarea
                  class="margin_0"
                  placeholder=""
                  label-width="1"
                  :prop="`list.${index}.dlnConfirmComment`"
                  rows="5"
                  show-word-limit
                  maxlength="500"
                />
              </vab-col>
            </vab-row>
            <vab-row class="row_box mess_box">
              <vab-messagerc
                :ref="`vabMessage${index}`"
                class="detail_nopadding message_collapse width_100 noborder"
                :title="'コメント履歴を閉じる'"
              />
            </vab-row>
          </div>
          <div class="flex_space mg12">
            <div class="flex_start">
              <div class="blgsnmkj_class">
                <svg-icon class="svg_icon" icon-class="select_work" />
                <el-link
                  type="primary"
                  @click="goCalendar(item.buildingCd, item.workYm, index, item)"
                >
                  カレンダーを表示
                </el-link>
              </div>
            </div>
            <vab-button
              :btn-list="item.btnList"
              :row="{ ...item, index: index }"
            />
          </div>
        </div>
      </div>
    </vab-form>
    <div v-if="form.list.length > 1" class="flex_end flex_center_align mt_12">
      <vab-button :btn-list="btnlist" />
    </div>
    <WorkPopupCalender ref="WorkPopupCalender" class="work_popup_calender" />

    <fixedTime
      ref="fixedTime"
      class="work_popup_calender"
      @saveData="saveData"
    />
  </div>
</template>

<script>
  import {
    getworkScheduleChange,
    cancelRequest,
    changeConfirm,
    changeRequest,
    changeUpdate,
  } from '@/api/rc/jobReservation'
  import { resetCalender } from '@/utils/index'

  export default {
    name: 'PWR01G04',
    provide() {
      return {
        vm: this,
      }
    },
    data() {
      return {
        info: {},
        visivleScheduled: false,
        visibleDay: false,
        form: { list: [] },
        rules: {},
        btnlist: [
          {
            name: '依頼',
            icon: 'answer',
            type: 'button',
            widht: '144',
            msgWidth: '144px',
            hidden: true,
            click: () => {
              this.changeRequestValid()
            },
          },
        ],
        changeCategoryList: [
          {
            code: this.$divisions.changeCategoryEnum.enum_0.code,
            value: this.$divisions.changeCategoryEnum.enum_0.value,
            text: this.$divisions.changeCategoryEnum.enum_0.text,
          },
          {
            code: this.$divisions.changeCategoryEnum.enum_1.code,
            value: this.$divisions.changeCategoryEnum.enum_1.value,
            text: this.$divisions.changeCategoryEnum.enum_1.text,
          },
        ],
        rcIdsList: [],
        num: null,
        resetCalenderList: null,
      }
    },
    computed: {
      vaildateTimeStart() {
        return (item, index) => {
          if (
            !(item.workDateFlag || this.$baseLodash.isEmpty(item.workPlanDate))
          ) {
            this.$set(this.rules, `list.${index}.workPlanStartTime`, [
              {
                required: true,
                message: this.format(
                  this.$t(
                    `validateMessage.${this.$messageCode.E00000001.name}`
                  ),
                  '予定日時'
                ),
                trigger: 'blur',
              },
            ])
          } else {
            this.$set(this.rules, `list.${index}.workPlanStartTime`, [
              {
                required: false,
                message: null,
              },
            ])
          }
        }
      },
      vaildateTimeEnd() {
        return (item, index) => {
          if (
            !(item.workDateFlag || this.$baseLodash.isEmpty(item.workPlanDate))
          ) {
            this.$set(this.rules, `list.${index}.workPlanEndTime`, [
              {
                required: true,
                message: this.format(
                  this.$t(
                    `validateMessage.${this.$messageCode.E00000001.name}`
                  ),
                  '予定日時'
                ),
                trigger: 'blur',
              },
            ])
          } else {
            this.$set(this.rules, `list.${index}.workPlanEndTime`, [
              {
                required: false,
                message: null,
              },
            ])
          }
        }
      },
    },
    mounted() {
      let rcIds = this.$route.query.rcIds
      if (rcIds.toString().indexOf(',') != -1) {
        this.rcIdsList = rcIds.split(',')
      }
      this.initData(rcIds)
    },
    methods: {
      // 初期化データ
      async initData(rcIds) {
        this.$baseColorfullLoading()
        try {
          let res = await getworkScheduleChange(rcIds)
          // 属性追加です
          this.setItem(res)
          // フォーマットbtnlistです
          if (res.length > 1) {
            res.filter((item) => {
              item.btnList = [
                {
                  name: '選択解除',
                  defaultColor: '#848484',
                  hover: '#848484',
                  type: 'plain',
                  widht: '76',
                  msg: this.$t(
                    `validateMessage.${this.$messageCode.I00000434.name}`
                  ),
                  hidden: false,
                  submitMethod: 'cancel',
                },
              ]
            })
            this.btnlist[0].hidden = false
            this.btnlist[0].name = '依頼（件数：' + res.length + '）'
          } else {
            this.btnListReset(res)
          }
          this.form.list = res
          this.form.list.forEach((item, index) => {
            if (item.changeCategory) {
              item.changeCategory = item.changeCategory.toString()
            }
            if (item.changeMonth) {
              item.changeMonth = item.changeMonth.toString()
            }
            // コンポーネント代入値です
            setTimeout(() => {
              if (this.workChangeSpecial(item)) {
                this.$refs[`localAdjRef${index}`][0].setValue(item.localAdjFlg)
              }
              if (item.commentHistory) {
                let commentList = JSON.parse(item.commentHistory)
                commentList.forEach((itemComment) => {
                  if (itemComment.company) {
                    itemComment.company =
                      this.$divisions.adjSourceClassEnum.enum_2.text
                  } else {
                    itemComment.partner =
                      this.$divisions.adjSourceClassEnum.enum_1.text
                  }
                })
                this.$refs[`vabMessage${index}`][0].setList(
                  JSON.stringify(commentList)
                )
              }
            }, 0)
          })
        } finally {
          this.$baseColorfullLoading().close()
        }
      },
      //元に戻す
      cancel(row) {
        this.rcIdsList.forEach((item, index) => {
          if (item == row.rowData.workingPlanAndResultRcId) {
            this.rcIdsList.splice(index, 1)
          }
        })
        if (this.rcIdsList.length == 1) {
          this.btnlist[0].hidden = true
        }
        const rcIds = this.rcIdsList.join(',')
        this.initData(rcIds)
      },
      // 個々の場合ですリファクタリング btnList
      btnListReset(list) {
        return list.filter((item) => {
          item.btnList = [
            {
              name: '依頼',
              icon: 'answer',
              type: 'button',
              widht: '104',
              hidden: (() => {
                if (
                  this.isEqualCodeEnum(
                    item.changeStatus,
                    this.$divisions.wparStatusEnum.enum_08
                  ) &&
                  !item.isMonthFlg
                ) {
                  return false
                } else {
                  return true
                }
              })(),
              click: () => {
                this.changeRequestValid()
              },
            },
            {
              name: '依頼取消',
              defaultColor: '#C90022',
              hover: '#E12432',
              type: 'plain',
              widht: '104',
              msg: this.$t(
                `validateMessage.${this.$messageCode.I00000378.name}`
              ),
              hidden: (() => {
                if (
                  ([
                    this.$divisions.wparStatusEnum.enum_02.value,
                    this.$divisions.wparStatusEnum.enum_03.value,
                    this.$divisions.wparStatusEnum.enum_04.value,
                  ].includes(item.changeStatus) &&
                    this.isEqualCodeEnum(
                      item.changeRequestFlg,
                      this.$divisions.changeRequestFlgEnum.enum_3
                    )) ||
                  (this.isEqualCodeEnum(
                    item.changeStatus,
                    this.$divisions.wparStatusEnum.enum_07
                  ) &&
                    this.isEqualCodeEnum(
                      item.changeCategory,
                      this.$divisions.changeCategoryEnum.enum_0
                    ) &&
                    this.isEqualCodeEnum(
                      item.changeRequestFlg,
                      this.$divisions.changeRequestFlgEnum.enum_3
                    ))
                ) {
                  return false
                } else {
                  return true
                }
              })(),
              click: () => {
                this.cancelRequest()
              },
            },
            {
              name: '更新',
              icon: 'answer',
              type: 'button',
              widht: '104',
              msg: this.$t(
                `validateMessage.${this.$messageCode.I00000382.name}`
              ),
              hidden: (() => {
                if (
                  [
                    this.$divisions.wparStatusEnum.enum_02.value,
                    this.$divisions.wparStatusEnum.enum_03.value,
                    this.$divisions.wparStatusEnum.enum_04.value,
                  ].includes(item.changeStatus) &&
                  [
                    this.$divisions.changeRequestFlgEnum.enum_1.value,
                    this.$divisions.changeRequestFlgEnum.enum_2.value,
                    this.$divisions.changeRequestFlgEnum.enum_3.value,
                    this.$divisions.changeRequestFlgEnum.enum_4.value,
                  ].includes(item.changeRequestFlg)
                ) {
                  return false
                } else {
                  return true
                }
              })(),
              click: () => {
                this.changeUpdate()
              },
            },
            {
              name: '確認',
              icon: 'answer',
              type: 'button',
              widht: '104',
              msg: this.$t(
                `validateMessage.${this.$messageCode.I00000380.name}`
              ),
              hidden: (() => {
                if (
                  this.isEqualCodeEnum(
                    item.changeStatus,
                    this.$divisions.wparStatusEnum.enum_09
                  ) ||
                  (this.isEqualCodeEnum(
                    item.changeStatus,
                    this.$divisions.wparStatusEnum.enum_07
                  ) &&
                    this.isEqualCodeEnum(
                      item.changeRequestFlg,
                      this.$divisions.changeRequestFlgEnum.enum_2
                    ) &&
                    this.isEqualCodeEnum(
                      item.changeCategory,
                      this.$divisions.changeCategoryEnum.enum_1
                    ))
                ) {
                  return false
                } else {
                  return true
                }
              })(),
              click: () => {
                this.changeConfirm()
              },
            },
          ]
        })
      },
      setItem(res) {
        res.filter((item) => {
          if (item.changeCategory == 1) {
            item.monthDisabled = false
          } else {
            item.monthDisabled = true
          }
          item.tempDate = item.workPlanDate
          item.tempStartTime = item.workPlanStartTime
          item.tempEndTime = item.workPlanEndTime
          item.isMonthFlg = false
          item.workDateFlag = false
          item.workFold = true
          if (this.isMonthChange(item)) item.isMonthFlg = true
          return item
        })
      },
      // 配列をフィルタリングします
      filterList(listItem) {
        delete listItem.btnList
        const data = {
          ...listItem,
        }
        data.workPlanStartTime = this.formatTimeMsel(
          data.workPlanStartTime,
          'HH:mm:ss:sss'
        )
        data.workPlanEndTime = this.formatTimeMsel(
          data.workPlanEndTime,
          'HH:mm:ss:sss'
        )
        if (
          data.workPlanDate &&
          (data.workPlanDate.length == 2 || data.workPlanDate.length == 1)
        ) {
          data.workPlanDate = this.$dayjs(
            data.workYm + data.workPlanDate
          ).format('YYYY/MM/DD')
        }
        return data
      },
      //作業日程変更 依頼取消
      async cancelRequest() {
        const data = this.filterList(this.form.list[0])
        const workingPlanAndResultRcId =
          this.form.list[0].workingPlanAndResultRcId
        this.$baseColorfullLoading()
        try {
          await cancelRequest(workingPlanAndResultRcId, data)
        } finally {
          this.$baseColorfullLoading().close()
        }
        this.$closePage(this.$route.path)
        this.$routerPushAndReload({
          name: 'PWR01G01',
          refresh: 'PWR01G01',
        })
        this.msgSuccess(
          this.format(
            this.$t(`validateMessage.${this.$messageCode.I00000266.name}`),
            '依頼取消'
          )
        )
      },
      //作業日程変更 確認
      async changeConfirm() {
        const data = this.filterList(this.form.list[0])
        this.$baseColorfullLoading()
        try {
          await changeConfirm(data)
        } finally {
          this.$baseColorfullLoading().close()
        }
        this.$closePage(this.$route.path)
        this.$routerPushAndReload({
          name: 'PWR01G01',
          refresh: 'PWR01G01',
        })
        this.msgSuccess(
          this.format(
            this.$t(`validateMessage.${this.$messageCode.I00000266.name}`),
            '確認'
          )
        )
      },
      //作業日程変更 更新
      async changeUpdate() {
        const data = this.filterList(this.form.list[0])
        this.$baseColorfullLoading()
        try {
          await changeUpdate(data)
        } finally {
          this.$baseColorfullLoading().close()
        }
        this.$closePage(this.$route.path)
        this.$routerPushAndReload({
          name: 'PWR01G01',
          refresh: 'PWR01G01',
        })
        this.msgSuccess(
          this.format(
            this.$t(`validateMessage.${this.$messageCode.I00000266.name}`),
            '更新'
          )
        )
      },
      //作業日程変更 変更依頼
      async changeRequest(data) {
        this.$baseColorfullLoading()
        try {
          await changeRequest(data)
        } finally {
          this.$baseColorfullLoading().close()
        }
        this.$closePage(this.$route.path)
        this.$routerPushAndReload({
          name: 'PWR01G01',
          refresh: 'PWR01G01',
        })
        this.msgSuccess(
          this.format(
            this.$t(`validateMessage.${this.$messageCode.I00000266.name}`),
            '依頼'
          )
        )
      },
      changeRequestValid() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let data = this.$baseLodash.cloneDeep(this.form.list)
            data.map((item) => {
              delete item.btnList
              if (
                item.workPlanStartTime &&
                item.workPlanStartTime.length == 5
              ) {
                item.workPlanStartTime += ':00:000'
              }
              if (item.workPlanEndTime && item.workPlanEndTime.length == 5) {
                item.workPlanEndTime += ':00:000'
              }
              if (
                item.workPlanDate &&
                (item.workPlanDate.length == 2 || item.workPlanDate.length == 1)
              ) {
                item.workPlanDate = this.$dayjs(
                  item.workYm + item.workPlanDate
                ).format('YYYY/MM/DD')
              }
            })
            this.$confirm({
              msg: this.format(
                this.$t(`validateMessage.${this.$messageCode.I00000381.name}`),
                '依頼'
              ),
              yesTex: '依頼',
              yes: async () => {
                this.changeRequest(data)
              },
            })
          } else {
            console.log('error submit!!')
          }
        })
      },
      // カレンダーを表示
      goCalendar(buildingCd, workYm, index, item) {
        this.info = {
          buildingCd,
          workYm: this.$dayjs(workYm.toString()).format('YYYY/MM'),
        }
        // this.workDay(index)
        this.visibleDay = true
        this.$refs.WorkPopupCalender.setParamsData({
          ...item,
          sectionCd: item?.workingPlanAndResultIdModel?.sectionCd,
          modeType: 'rc',
          resetCalenderList: [item]?.map((item) => {
            let day = null
            if (this.workChangeSpecial(item)) {
              day = item?.workPlanDate
            } else {
              day = this.$dayjs(item?.workPlanDate).format('DD')
            }

            return {
              ...item,
              day: day,
            }
          }),
        })
      },
      // カレンダー表示データをリセット
      workDay(index) {
        let cloneList = this.$baseLodash.cloneDeep(this.form.list)
        if (
          !this.$baseLodash.isNull(cloneList[index]?.workPlanDate) &&
          cloneList[index]?.workPlanDate.length > 2
        ) {
          cloneList[index].workPlanDate =
            cloneList[index]?.workPlanDate.slice(-2)
        }
        this.resetCalenderList = resetCalender(
          [cloneList[index]],
          this.$divisions.changeFlgEnum.enum_3.value
        )
      },
      // 依頼種別選択
      changeSelectCategory(val, index) {
        // ※「変更」「月変更」を選択の時：依頼日、日程回答期限、変更後日時、現地確認、現地確認要否 ==> 空にします  And  変更後日時 ===> 変更前日時
        this.form.list[index].answerDeadline = null
        this.form.list[index].changeRequestDate = null
        this.form.list[index].localComfirmFlg = null
        this.form.list[index].localAdjFlg = null
        this.form.list[index].workChangeDate = this.form.list[index].tempDate
        this.form.list[index].workChangeStartTime =
          this.form.list[index].tempStartTime
        this.form.list[index].workChangeEndTime =
          this.form.list[index].tempEndTime
        this.form.list[index].workPlanDate = null
        this.form.list[index].workPlanStartTime = null
        this.form.list[index].workPlanEndTime = null
        if (
          this.isEqualCodeEnum(val, this.$divisions.changeCategoryEnum.enum_1)
        ) {
          this.form.list[index].monthDisabled = false
          this.form.list[index].localAdjFlg = null
          this.form.list[index].workDateFlag = false
        } else {
          this.form.list[index].workDateFlag = false
          this.form.list[index].monthDisabled = true
          this.form.list[index].changeMonth = null
          this.form.list[index].localAdjFlg =
            this.$divisions.localAdjFlgEnum.enum_0.value
          this.$nextTick(() => {
            this.$refs[`localAdjRef${index}`][0].setValue(
              this.$divisions.localAdjFlgEnum.enum_0.value
            )
          })
        }
      },
      // 変更日時選択
      checkboxWorkPlan(val, index) {
        if (!val) {
          this.form.list[index].localAdjFlg =
            this.$divisions.localAdjFlgEnum.enum_0.value
          this.$nextTick(() => {
            this.$refs[`localAdjRef${index}`][0].setValue(
              this.$divisions.localAdjFlgEnum.enum_0.value
            )
          })
        } else {
          this.form.list[index].localAdjFlg = null
        }
        this.form.list[index].workDateFlag = val
        this.form.list[index].workPlanDate = null
        this.form.list[index].workPlanStartTime = null
        this.form.list[index].workPlanEndTime = null
      },
      // 月の変更ですか
      isMonthChange(item) {
        return (
          this.isEqualCodeEnum(
            item.changeStatus,
            this.$divisions.wparStatusEnum.enum_08
          ) &&
          this.isEqualCodeEnum(
            item.changeCategory,
            this.$divisions.changeCategoryEnum.enum_1
          )
        )
      },
      // 依頼内容
      isChangeCategory(item) {
        if (this.isChangeFlg(item)) return false
        return this.isEqualCodeEnum(
          item.changeStatus,
          this.$divisions.wparStatusEnum.enum_08
        )
      },
      // 入力可能かどうかです
      workChangeSpecial(item) {
        if (this.isChangeFlg(item)) return false
        return (
          (([
            this.$divisions.wparStatusEnum.enum_02.value,
            this.$divisions.wparStatusEnum.enum_03.value,
            this.$divisions.wparStatusEnum.enum_04.value,
          ].includes(item.changeStatus) &&
            [
              this.$divisions.changeRequestFlgEnum.enum_1.value,
              this.$divisions.changeRequestFlgEnum.enum_2.value,
              this.$divisions.changeRequestFlgEnum.enum_3.value,
              this.$divisions.changeRequestFlgEnum.enum_4.value,
            ].includes(item.changeRequestFlg)) ||
            this.isEqualCodeEnum(
              item.changeStatus,
              this.$divisions.wparStatusEnum.enum_08
            )) &&
          this.isEqualCodeEnum(
            item.changeCategory,
            this.$divisions.changeCategoryEnum.enum_0
          )
        )
      },
      // 中止ですか
      isChangeFlg(item) {
        return this.isEqualCodeEnum(
          item.changeFlg,
          this.$divisions.changeFlgEnum.enum_3
        )
      },
      // 予定日時
      openDay(item, index) {
        if (item.workDateFlag) return
        this.num = index
        let cloneData = this.$baseLodash.cloneDeep(item)
        cloneData = {
          ...cloneData,
          requestYearMonth: this.formatDateTime(
            this.$baseLodash.toString(item.workYm),
            this.$const.dateFormatYYYYMMDD
          ),
          day: item?.workPlanDate,
          startTime: this.formatTimeMsel(item?.workPlanStartTime, 'HH:mm'),
          endTime: this.formatTimeMsel(item?.workPlanEndTime, 'HH:mm'),
        }
        this.$refs.fixedTime.setParamsData(cloneData)
      },
      saveData(val) {
        this.form.list[this.num].workPlanDate = val.day
        this.form.list[this.num].workPlanStartTime = val.startTime
        this.form.list[this.num].workPlanEndTime = val.endTime
      },
      // 更新日です
      updateTime(times) {
        const timeObj = JSON.parse(times)
        this.form.list[timeObj.index].workPlanDate = timeObj.date
        this.form.list[timeObj.index].workPlanStartTime = timeObj.startTime
        this.form.list[timeObj.index].workPlanEndTime = timeObj.endTime
        this.visivleScheduled = false
      },
      update() {
        this.visivleScheduled = false
      },
      // フォーマットタイムです
      formatWorkPlanDate(val, ym) {
        if (!this.$baseLodash.isEmpty(val)) {
          let len = val.toString().length
          if (len === 2 || len === 1) {
            val =
              this.$dayjs(ym.toString()).format('YYYY/MM') +
              (len === 1 ? '/0' : '/') +
              val
          }
        }
        return val
      },
      // 値があるかどうかです
      isShow(val1, val2, val3) {
        if (
          this.$baseLodash.isEmpty(val1) &&
          this.$baseLodash.isEmpty(val2) &&
          this.$baseLodash.isEmpty(val3)
        ) {
          return '-'
        } else {
          return ''
        }
      },
      // リセット時間です
      timeReset(val, index) {
        if (!val) {
          this.form.list[index].workPlanDate = null
          this.form.list[index].workPlanStartTime = null
          this.form.list[index].workPlanEndTime = null
        }
      },
      getChangeMonth(val) {
        if (this.$baseLodash.isEmpty(val) || !this.$dayjs(val).isValid()) return
        return this.$dayjs(val.toString()).format('MM') * 1 + '月'
      },
    },
  }
</script>
